<div class="split-button" [class.disabled]="disabled">
  <div class="split-first-button">
    <ng-content select="[first-button]"></ng-content>
  </div>
  <div class="split-second-button">
    <ng-content select="[second-button]"></ng-content>
  </div>
</div>
